import { render, staticRenderFns } from "./fi_page_rail.vue?vue&type=template&id=92736752&scoped=true&"
import script from "./fi_page_rail.vue?vue&type=script&lang=js&"
export * from "./fi_page_rail.vue?vue&type=script&lang=js&"
import style0 from "./fi_page_rail.vue?vue&type=style&index=0&id=92736752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92736752",
  null
  
)

export default component.exports